class StickyScrollShowcase extends HTMLElement {
  connectedCallback() {
    this.steps = Array.from(this.querySelectorAll('.sticky-scroll-showcase__step'));

    if (this.steps.length === 0) return;

    // Shorter mobile image+text blocks need a lower threshold to fade in reliably
    const isMobile = window.matchMedia('(max-width: 699px)').matches;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in-view');
          }
        });
      },
      {
        root: null,
        threshold: isMobile ? 0.2 : 0.45,
        rootMargin: isMobile ? '0px 0px -5% 0px' : '0px 0px -10% 0px'
      }
    );

    this.steps.forEach((step) => this.observer.observe(step));
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('sticky-scroll-showcase')) {
  customElements.define('sticky-scroll-showcase', StickyScrollShowcase);
}
